import { createContext, useContext } from "react";
import type { MaterialSymbol } from "../components";

export interface PageMetadata {
  title: string;
  icon?: MaterialSymbol;
  crumb?: boolean;
  badge?: React.ReactElement;
  menu?: React.ReactElement;
  nav?: React.ReactElement;
}

export interface MetadataState {
  metadata: PageMetadata[];
  handleMetadata: (metadata: PageMetadata) => void;
}

export const defaultMetadataState: MetadataState = {
  metadata: [{ title: "QuoteWell" }],
  handleMetadata: () => {},
};

export const MetaData = createContext<MetadataState>(defaultMetadataState);

export const useMetadata = () => {
  const context = useContext(MetaData);

  if (context === undefined) {
    throw new Error("useMetadata must be used within a MetadataProvider");
  }

  return context;
};
